import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos cargos
 */
export class PartsComandRequests {
    /**
     * Faz a requisição para pegar uma PartCommand
     * @param {string} id da PartCommand a ser pega
     */
    async getPartCommand(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommands/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar a PartCommand
     * @param id id da PartCommand a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editPartCommands(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommands/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar uma PartCommand
     * @param id id da PartCommand a ser deletada
     */
    async deletePartCommand(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommands/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar todas PartCommands
     */
    async getAllPartCommands():Promise<any>{
        try {
            const response = await api.get(`/PartCommands`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criação de uma PartCommand
     * @param Body informações da PartCommand a ser criada
     */
    async CreatePartCommands(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommands`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Busca as categorias padrões
     */
    async getDefaultCategoriesCommands():Promise<any>{
        try {
            const response = await api.get(`/DefaultCategoriesCommands`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Busca as variáveis existentes
     */
    async getPartCommandsVariables():Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariables`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criar uma variavel
     * @param Body informações da variavel a ser criada
     */
    async SavePartCommandVariable(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariables`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar uma PartCommandvariable
     * @param id id da PartCommandvariable a ser buscada
     */
    async getPartCommandVariable(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariables/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar uma PartCommandvariable
     * @param id id da PartCommandvariable a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editPartCommandVariable(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariables/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar uma PartCommandvariable
     * @param id id da PartCommandvariable a ser deletada
     */
    async deletePartCommandVariable(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommandsVariables/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar ligações entre PartCommand e PartCommandvariable
     */
    async getPartCommandsHasVariables():Promise<any>{
        try {
            const response = await api.get(`/PartCommandsHasVariables`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criar uma ligação entre PartCommand e PartCommandvariable
     * @param Body informações da ligação a ser criada
     */
    async SavePartCommandHasVariable(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsHasVariables`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Busca uma ligação entre PartCommand e PartCommandvariable
     * @param id id da ligação a ser buscada
     */
    async getPartCommandHasVariable(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommandsHasVariables/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar uma ligação entre PartCommand e PartCommandvariable
     * @param id id da ligação a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editPartCommandHasVariable(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsHasVariables/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar uma ligação entre PartCommand e PartCommandvariable
     * @param id id da ligação a ser deletada
     */
    async deletePartCommandHasVariable(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommandsHasVariables/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição de todos alarmes
     */
    async getPartCommandsVariablesAlarms():Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariablesAlarms`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criar um alarme
     * @param Body informações do alarme a ser criado
     */
    async SavePartCommandVariableAlarm(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAlarms`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar um alarme
     * @param id id do alarme a ser buscado
     */
    async getPartCommandVariableAlarm(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariablesAlarms/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar um alarme
     * @param id id do alarme a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editPartCommandVariableAlarm(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAlarms/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar um alarme
     * @param id id do alarme a ser deletado
     */
    async deletePartCommandVariableAlarm(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommandsVariablesAlarms/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar ligação entre partcommand e equipamento
     */
    async getEquipmentHasPartsCommands():Promise<any>{
        try {
            const response = await api.get(`/EquipmentHasPartsCommands`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criar ligação entre partcommand e equipamento
     * @param Body informações da ligação a ser criada
     */
    async SaveEquipmentHasPartsCommand(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/EquipmentHasPartsCommands`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar ligação entre partcommand e equipamento
     * @param id id da ligação a ser buscada
     */
    async getEquipmentHasPartsCommand(id: string):Promise<any>{
        try {
            const response = await api.get(`/EquipmentHasPartsCommands/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar ligação entre partcommand e equipamento
     * @param id id da ligação a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editEquipmentHasPartsCommand(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/EquipmentHasPartsCommands/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar ligação entre partcommand e equipamento
     * @param id id da ligação a ser deletada
     */
    async deleteEquipmentHasPartsCommand(id : string):Promise<any>{
        try {
            const response = await api.delete(`/EquipmentHasPartsCommands/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar os equipamentos autorizados
     */
    async getEquipments(): Promise<any>{
        try {
            const pocos = await api.get(`/me/authorizedEquipmentsCommandsInterface`);
            return pocos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar os grupos de variáveis
     */
    async getGroupsVariables(): Promise<any>{
        try {
            const grupos = await api.get(`/EncapsuledVariablesGroups`);
            return grupos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar um grupo de variáveis
     * @param Body informações do grupo a ser criado
     */
    async SaveGroupVariable(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/EncapsuledVariablesGroups`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para busca um grupo de variáveis
     * @param id id do grupo a ser buscado
     */
    async getGroupVariable(id: string):Promise<any>{
        try {
            const response = await api.get(`/EncapsuledVariablesGroups/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar um grupo de variáveis
     * @param id id do grupo a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editGroupVariable(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/EncapsuledVariablesGroups/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar um grupo de variáveis
     * @param id id do grupo a ser deletado
     */
    async deleteGroupVariable(id : string):Promise<any>{
        try {
            const response = await api.delete(`/EncapsuledVariablesGroups/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar as unidades de medida
     */
    async getUnits(): Promise<any>{
        try {
            const unidades = await api.get(`/PartCommandsVariablesAcceptUnits`);
            return unidades.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar uma unidade de medida
     * @param Body informações da unidade a ser criada
     */
    async SaveUnit(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAcceptUnits`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar uma unidade de medida
     * @param id id da unidade a ser buscada
     */
    async getUnit(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariablesAcceptUnits/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar uma unidade de medida
     * @param id id da unidade a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editUnit(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAcceptUnits/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar uma unidade de medida
     * @param id id da unidade a ser deletada
     */
    async deleteUnit(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommandsVariablesAcceptUnits/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar os valores aceitos
     */
    async getAcceptValues(): Promise<any>{
        try {
            const valores = await api.get(`/PartCommandsVariablesAcceptValues`);
            return valores.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar um valor aceito
     * @param Body informações do valor a ser criado
     */
    async SaveAcceptValue(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAcceptValues`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para buscar um valor aceito
     * @param id id do valor a ser buscado
     */
    async getAcceptValue(id: string):Promise<any>{
        try {
            const response = await api.get(`/PartCommandsVariablesAcceptValues/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar um valor aceito
     * @param id id do valor a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editAcceptValue(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/PartCommandsVariablesAcceptValues/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para deletar um valor aceito
     * @param id id do valor a ser deletado
     */
    async deleteAcceptValue(id : string):Promise<any>{
        try {
            const response = await api.delete(`/PartCommandsVariablesAcceptValues/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}